<div class="mb-6 inline-block w-full">
  <div class="flex">
    <patternlib-table-base>
      <tr slot="head">
        <th>
          <patternlib-checkbox
            class="ml-2"
            [checked]="this.selectedAll"
            (lhChange)="this.onSelectAllRows($event)"
          >
          </patternlib-checkbox>
        </th>
      </tr>
      <patternlib-table-base-row *ngFor="let row of this.documentsOnThisPage">
        <patternlib-table-base-cell>
          <div class="ml-2">
            <patternlib-checkbox
              [checked]="row.selected"
              (lhChange)="this.onSelectRow(row, $event)"
            >
            </patternlib-checkbox>
          </div>
        </patternlib-table-base-cell>
      </patternlib-table-base-row>
    </patternlib-table-base>
    <div class="overflow-auto relative table-split-shadow-right">
      <div
        class="absolute left-0 top-0 h-full w-[25px] z-10 table-split-shadow-left"
      ></div>
      <patternlib-table-base>
        <tr slot="head">
          <th class="whitespace-nowrap" *ngIf="this.categoriesAvailable">
            {{ "category" | translate }}
          </th>
          <th class="whitespace-nowrap w-screen" *ngIf="this.fileNameAvailable">
            {{ "name" | translate }}
          </th>
          <th class="whitespace-nowrap">{{ "documentType" | translate }}</th>
          <th class="whitespace-nowrap">{{ "language" | translate }}</th>
          <th class="whitespace-nowrap" *ngIf="this.fileSizeAvailable">
            {{ "fileSize" | translate }}
          </th>
          <th class="whitespace-nowrap" *ngIf="this.pageCountAvailable">
            {{ "pageCount" | translate }}
          </th>
          <th class="whitespace-nowrap">{{ "creationDate" | translate }}</th>
        </tr>
        <patternlib-table-base-row *ngFor="let row of this.documentsOnThisPage">
          <patternlib-table-base-cell
            class="whitespace-nowrap h-56"
            *ngIf="this.categoriesAvailable"
          >
            {{ row.data.category }}
          </patternlib-table-base-cell>
          <patternlib-table-base-cell
            class="whitespace-nowrap"
            *ngIf="this.fileNameAvailable"
          >
            {{ row.data.fileName }}
          </patternlib-table-base-cell>
          <patternlib-table-base-cell class="whitespace-nowrap">
            {{ row.data.documentType }}
          </patternlib-table-base-cell>
          <patternlib-table-base-cell class="whitespace-nowrap">
            {{ row.data.languagesHumanReadable.join(", ") }}
          </patternlib-table-base-cell>
          <patternlib-table-base-cell
            class="whitespace-nowrap"
            *ngIf="this.fileSizeAvailable"
          >
            {{ row.data.fileSizeHumanReadable }}
          </patternlib-table-base-cell>
          <patternlib-table-base-cell
            class="whitespace-nowrap"
            *ngIf="this.pageCountAvailable"
          >
            {{ row.data.pageCount }}
          </patternlib-table-base-cell>
          <patternlib-table-base-cell class="whitespace-nowrap">
            {{ row.data.creationDate | date: "mediumDate" }}
          </patternlib-table-base-cell>
        </patternlib-table-base-row>
      </patternlib-table-base>
    </div>
    <div class="relative w-40">
      <patternlib-table-base>
        <tr slot="head" class="text-end">
          <th>{{ "actions" | translate }}</th>
        </tr>
        <patternlib-table-base-row *ngFor="let row of this.documentsOnThisPage">
          <patternlib-table-base-cell>
            <div class="text-end">
              <a [href]="getDownloadLink(row.data)">
                <patternlib-tooltip>
                  <patternlib-icon icon-name="download"></patternlib-icon>
                  <div slot="content" class="text-center py-2 mx-3">
                    {{ "button_download" | translate }}
                  </div>
                </patternlib-tooltip>
              </a>
            </div>
          </patternlib-table-base-cell>
        </patternlib-table-base-row>
      </patternlib-table-base>
    </div>
  </div>
  <div
    class="flex items-center min-h-[50px] py-[11px] px-[24px] border-t border-t-solid border-t-gray-300 bg-gray-100"
  >
    <patternlib-pagination
      [currentPage]="this.currentPage"
      [lastPage]="this.lastPage"
      (lhChange)="this.onPageChange($event)"
    >
      <patternlib-dropdownsubtle
        size="small"
        width="85px"
        slot="dropdown"
        value="10"
        (lhSelect)="this.onItemsPerPageChange($event)"
      >
        <patternlib-option value="10" label="10"></patternlib-option>
        <patternlib-option value="20" label="20"></patternlib-option>
        <patternlib-option value="25" label="25"></patternlib-option>
        <patternlib-option value="50" label="50"></patternlib-option>
        <patternlib-option value="75" label="75"></patternlib-option>
        <patternlib-option value="100" label="100"></patternlib-option>
      </patternlib-dropdownsubtle>
      <span slot="dropdown-label">{{
        "search_results_per_page" | translate
      }}</span>
      <span slot="dropdown-range-label">
        {{ this.pageIndexStart + 1 }} - {{ this.pageIndexEnd }}
        {{ "of" | translate }}
        {{ this.rows.length }}
      </span>
    </patternlib-pagination>
  </div>
</div>
